import React from 'react';
import { Zap, Lightbulb, Users } from 'lucide-react';

const features = [
  {
    icon: Zap,
    title: 'Work Faster',
    description: 'Reduce repetitive tasks and focus on what matters. AI handles the busywork so your team can move quickly.',
  },
  {
    icon: Lightbulb,
    title: 'Create Better',
    description: 'Generate ideas, refine content, and produce professional-quality work with intelligent assistance at every step.',
  },
  {
    icon: Users,
    title: 'Collaborate Seamlessly',
    description: 'Work across teams and time zones with tools that keep everyone aligned and productive.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="pt-14 pb-20 sm:py-20 lg:py-32 px-4 sm:px-6 lg:px-12 bg-gradient-to-b from-white via-gray-50/50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-light tracking-tight text-gray-900 mb-6">
            Why teams choose Longfloat
          </h2>
          <p className="text-lg text-gray-600 font-light max-w-3xl mx-auto leading-relaxed">
            AI that fits into your workflow, not the other way around.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="text-center group animate-fade-in-stagger"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="inline-flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-gray-100 text-gray-900 mb-6 sm:mb-8 transition-all duration-500 group-hover:bg-gray-900 group-hover:text-white group-hover:scale-105">
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl sm:text-3xl font-light tracking-tight text-gray-900 mb-3 sm:mb-4">
                  {feature.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in-stagger {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in-stagger {
          animation: fade-in-stagger 0.8s ease-out both;
        }
      `}</style>
    </section>
  );
}
